<template>
  <div class="layout">
    <!-- 官网框架 -->
    <!-- 头部 -->
    <nav-bar></nav-bar>
    <div class="fixedHeight"></div>
    <!-- 中间 -->
    <main>
      <router-view></router-view>
    </main>
    <!-- 底部 -->
    <vFooter></vFooter>
    <i
      class="iconfont icon-huidaodingbu"
      :style="{ opacity: scrollTop > 500 ? 1 : 0 }"
      @click="scrollToTop"
    ></i>
  </div>
</template>

<script>
import navBar from "./navBar/index.vue";
import vFooter from "./footer/index.vue";
export default {
  data() {
    return {
      scrollTop: 0,
    };
  },
  components: {
    navBar,
    vFooter,
  },
  mounted() {
    window.addEventListener("scroll", () => {
      this.scrollTop = document.documentElement.scrollTop;
    });
  },
  methods: {
    scrollToTop() {
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.fixedHeight {
  height: 5rem;
}
.icon-huidaodingbu {
  position: fixed;
  color: #fff;
  background-color: rgba(0, 0, 0, 0.5);
  cursor: pointer;
  right: 0;
  text-align: center;
  display: block;
  z-index: 1000;
  opacity: 0;
  transition: all 0.6s;
}
/*媒体查询*/
/*屏幕宽度大于1024px的时候执行里面的css*/
@media only screen and (min-width: 1024px) {
  .icon-huidaodingbu {
    width: 4rem /* 64/16 */;
    height: 4rem /* 64/16 */;
    line-height: 4rem /* 64/16 */;
    bottom: 6.25rem /* 100/16 */;
  }
}
/*媒体查询*/
/*屏幕宽度小于1024px的时候执行里面的css*/
@media only screen and (max-width: 1024px) {
  .icon-huidaodingbu {
    width: 2.8125rem /* 45/16 */;
    height: 2.8125rem /* 45/16 */;
    line-height: 2.8125rem /* 45/16 */;
    bottom: 10.5rem /* 168/16 */;
    font-size: 0.75rem /* 12/16 */ !important;
  }
}
</style>


// WEBPACK FOOTER //
// src/layout/index.vue